import { Button, Divider, Typography } from "@suraasa/placebo-ui"
import ErrorPage from "components/ErrorPage"
import FullPageLoading from "components/FullPageLoading"
import { useSuraasaPlusContext } from "features/SuraasaPlus/context"
import { CheckCircleSolid } from "iconoir-react"
import { Link } from "react-router-dom"
import routes from "routes"
import { formatDate } from "utils/helpers"
import useFormatPrice from "utils/hooks/useFormatPrice"

import { getLogoSrc, SubscriptionSlugs } from "../helper"

const AlreadyPaidScreen = ({ productSlug }: { productSlug: string }) => {
  const formatPrice = useFormatPrice()

  const { subscriptionDetailsQuery, subscriptionDetails } =
    useSuraasaPlusContext()

  const transaction = subscriptionDetails?.transactions?.[0]

  const logoSrc = getLogoSrc(productSlug as SubscriptionSlugs)

  if (subscriptionDetailsQuery?.isLoading)
    return <FullPageLoading debugMessage="From AlreadyPaidScreen.tsx" />

  if (!subscriptionDetails)
    return (
      <ErrorPage
        errorStatus={500}
        debugMessage="Transactions list came empty"
      />
    )

  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 z-0 min-h-screen bg-[linear-gradient(180deg,#D4F8F1_0%,#FEFEFF_13.4%,#F8FAFC_89.31%)] sm:bg-[linear-gradient(180deg,#D4F8F1_0%,#FEFEFF_46.4%,#F8FAFC_100%)]" />
      <div className="absolute inset-0 z-10 flex justify-center p-2 sm:items-center">
        <div className="flex max-w-md flex-col rounded-3xl p-4 sm:border sm:border-onSurface-200 sm:bg-white sm:shadow-[0px_6px_15px_0px_#0000000D]">
          <CheckCircleSolid className="mb-3 size-5 text-success-600" />
          <Typography variant="title2" className="mb-1">
            Welcome to Suraasa Plus!
          </Typography>
          {transaction && (
            <Typography variant="title3" className="mt-2">
              {transaction.currency.symbol}
              {formatPrice(transaction.amount)}
            </Typography>
          )}
          <Typography variant="largeBody" className="mb-6">
            {transaction ? "Payment Received" : "Subscription activated"} on{" "}
            {formatDate(subscriptionDetails.subscription.lastPaymentDate)}
          </Typography>
          <div className="flex flex-wrap gap-2 md:mb-2">
            <img
              alt="logo"
              src={logoSrc}
              className="size-[52px] shrink-0 overflow-hidden rounded-xl border border-surface-100 object-cover"
            />
            <div className="mb-4.5 flex flex-col gap-0.75">
              <Typography variant="strong">
                {subscriptionDetails.product?.name}
              </Typography>
              <Typography variant="preTitle" className="text-onSurface-500">
                SUBSCRIPTION
              </Typography>
            </div>
          </div>
          <Divider weight="light" className="-mx-4 mb-4 hidden sm:block" />

          <Link to={getRedirectUrl()}>
            <Button label="Continue" color="black" className="w-full" />
          </Link>
        </div>
      </div>
    </div>
  )
}

const getRedirectUrl = () => {
  const next =
    new URLSearchParams(window.location.search).get("next") || routes.home

  return new URL(next, window.location.origin).toString()
}

export default AlreadyPaidScreen
